import React from 'react';
import "../../../constants/styles/loading.scss";
import '../../../constants/styles/summaryPanel.scss';

function SummaryTranscript({ summaryData, isEditing, isSavingChanges }) {
    return (
        <div className="summaryTranscriptContent custom-scrollbars">
            {summaryData ? (
                <table className={`${isEditing && !isSavingChanges ? 'greyBackground' : ''}`}>
                    <tbody>
                    {summaryData["narrative summary"] && (
                        <tr>
                            <td colSpan="2">
                                <p className="titlep">Narrative Summary</p>
                                <ul className="narrative-summary-list">
                                    {summaryData["narrative summary"].map((item, index) => (
                                        <li key={`narrative-${index}`}>{item["narrative sentence"]}</li>
                                    ))}
                                </ul>
                            </td>
                        </tr>
                    )}
                    {summaryData["key information"] && summaryData["key information"].map((item, index) => (
                        <tr key={`key-info-${index}`}>
                            <td className="title">{item.name}</td>
                            <td>{item.information}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            ) : (
                <div className="loadingScreen">
                    <div className="loading-spinner"></div>
                    <p>Generating summary...</p>
                </div>
            )}
        </div>
    );
}

export default SummaryTranscript;
